import PageDetails from "../../general/details";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import {useContext, useEffect} from "react";
import AppContext from "../../../context/app/context";
import Spin from "../../general/antd/spin";
import Descriptions from "../../general/antd/descriptions";
import {Descriptions as AntdDescriptions} from "antd";
import OldImage from "../../form-components/old-image";
import CategoryCampaignContext from "../../../context/category-campaign/context";
import CategoryCampaignContextProvider from "../../../context/category-campaign/provider";

interface Props {
}

const CategoryCampaign: React.FC<Props> = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {id} = useParams();
    const {details, actions, loading} = useContext(CategoryCampaignContext);
    const {direction} = useContext(AppContext);

    useEffect(() => {
        const getDetails = async () => {
            id && (await actions.getDetails(Number(id)));
        };
        getDetails();
    }, [direction]);

    return (
        <PageDetails
            title={t("details")}
            subtitle={t("campaigns_manager")}
            buttonName={`${t("update_category_campaigns")}`}
            onClick={() => navigate(`/categories_campaigns/update/${id}`)}
        >
            {loading.includes("details") ? (
                <Spin/>
            ) : (
                <Descriptions size="small" column={1} bordered>
                    <AntdDescriptions.Item label={t("id")}>
                        {details?.id}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("note")}>
                        {details?.note ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("priority")}>
                        {details?.priority ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("image")}>
                        {details?.image ? (
                            <OldImage preview src={details?.image?.url} />
                        ) : (
                            "-"
                        )}
                    </AntdDescriptions.Item>
                </Descriptions>
            )}
        </PageDetails>
    )
}

const CategoryCampaignDetailsPage = () => {
    return (
        <CategoryCampaignContextProvider>
            <CategoryCampaign/>
        </CategoryCampaignContextProvider>
    );
};
export default CategoryCampaignDetailsPage;